<div class="container" *ngIf="certificate" [ngClass]="{'loaded': isLoaded}">
    <div class="row mb-3">
        <div class="col">
            <div class="card text-center">
                <div class="card-header bg-success">
                    <h3 class="mb-0">
                        <i class="fa fa-id-card-o"></i> Certificate 
                        <strong>#{{certificate.certificateNumber}}</strong> | 
                        <i class="fa fa-user-circle"></i> Owner: 
                        <strong>{{certificate.firstName}} {{certificate.lastName}}</strong>
                    </h3>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-4 align-items-stretch">
            <div class="card h-100">
                <div class="card-header bg-info">
                    <h4 class="mb-0"><i class="fa fa-car"></i> Vehicle & Dealer</h4>
                </div>
                <div class="card-body">
                    <table class="table table-striped table-sm">
                        <tbody>
                            <tr>
                                <th scope="row"><i class="fa fa-car"></i> Make & Model</th>
                                <td>{{certificate.vehicleMake}} {{certificate.model}}</td>
                            </tr>
                            <tr>
                                <th scope="row"><i class="fa fa-hashtag"></i> Reg. Number</th>
                                <td>{{certificate.registrationNumber || 'N/A'}}</td>
                            </tr>
                            <tr>
                                <th scope="row"><i class="fa fa-barcode"></i> VIN/Chassis</th>
                                <td>{{certificate.chasisNumber || 'N/A'}}</td>
                            </tr>
                            <tr>
                                <th scope="row"><i class="fa fa-building"></i> Dealer</th>
                                <td>{{certificate.dealerName || 'N/A'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-lg-4 align-items-stretch">
            <div class="card h-100">
                <div class="card-header bg-warning">
                    <h4 class="mb-0"><i class="fa fa-user"></i> Owner & Contact Details</h4>
                </div>
                <div class="card-body">
                    <table class="table table-striped table-sm">
                        <tbody>
                            <tr>
                                <th scope="row"><i class="fa fa-user-circle"></i> Name</th>
                                <td>{{certificate.firstName}} {{certificate.lastName}}</td>
                            </tr>
                            <tr>
                                <th scope="row"><i class="fa fa-phone"></i> Contact</th>
                                <td>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>{{certificate.contactNumber}}</span>
                                        <button class="btn btn-sm btn-outline-secondary" 
                                            (click)="onCopyContact(certificate.contactNumber)"
                                            title="Copy contact number">
                                            <i class="fa fa-copy"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th scope="row"><i class="fa fa-map-marker"></i> State</th>
                                <td>{{certificate.state || 'N/A'}}</td>
                            </tr>
                            <tr>
                                <th scope="row"><i class="fa fa-building"></i> City</th>
                                <td>{{certificate.city || 'N/A'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-lg-4 align-items-stretch">
            <div class="card h-100" [ngClass]="{'border-danger': isCertificateExpired}">
                <div class="card-header" [ngClass]="{'bg-danger': isCertificateExpired, 'bg-success': !isCertificateExpired}">
                    <h4 class="mb-0">
                        <i class="fa fa-calendar-check-o"></i> Coverage Details
                        <span *ngIf="isCertificateExpired" class="badge bg-warning float-end">EXPIRED</span>
                    </h4>
                </div>
                <div class="card-body">
                    <table class="table table-striped table-sm">
                        <tbody>
                            <tr>
                                <th scope="row"><i class="fa fa-calendar-plus-o"></i> Start Date</th>
                                <td>{{certificate.startDate | date:'mediumDate'}}</td>
                            </tr>
                            <tr>
                                <th scope="row"><i class="fa fa-calendar-times-o"></i> End Date</th>
                                <td>
                                    <span [ngClass]="{'text-danger fw-bold': isCertificateExpired}">
                                        {{certificate.endDate | date:'mediumDate'}}
                                        <i *ngIf="isCertificateExpired" class="fa fa-exclamation-circle text-danger ms-2" title="Certificate expired"></i>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th scope="row"><i class="fa fa-ambulance"></i> RSA Services</th>
                                <td>
                                    <span class="badge" 
                                          [ngClass]="{'bg-danger': +certificate.rsaProvidedCount >= +certificate.rsaNumberOfServices, 'bg-success': +certificate.rsaProvidedCount < +certificate.rsaNumberOfServices}">
                                        {{certificate.rsaProvidedCount}} / {{certificate.rsaNumberOfServices}}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th scope="row"><i class="fa fa-file-text-o"></i> Plan Type</th>
                                <td>{{certificate.policyType}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col text-center">
            <div class="action-panel">
                <div *ngIf="isCertificateExpired" class="alert alert-danger mb-3">
                    <i class="fa fa-exclamation-triangle"></i> 
                    <strong>Certificate is expired or has reached maximum services.</strong> 
                    No new RSA services can be added.
                </div>
                
                <!-- Mobile-friendly button with larger tap target -->
                <button 
                    [disabled]="loading" 
                    class="btn btn-lg btn-primary w-100 mb-2" 
                    (click)="onAddNewRsaService()" 
                    *ngIf="!isCertificateExpired">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
                    <i class="fa fa-plus-circle"></i> Add New RSA Service
                </button>
                
                <div class="mt-3 text-muted" *ngIf="!isCertificateExpired">
                    <small>Click to add a new RSA service record for this certificate</small>
                </div>
                
                <!-- Service counter with improved styling -->
                <div class="mt-3" *ngIf="certificate">
                    <div class="d-flex justify-content-center">
                        <div 
                            class="badge fs-6" 
                            [ngClass]="{'bg-danger': +certificate.rsaProvidedCount >= +certificate.rsaNumberOfServices, 'bg-success': +certificate.rsaProvidedCount < +certificate.rsaNumberOfServices}">
                            <i class="fa fa-tasks me-2"></i>
                            Services Used: {{certificate.rsaProvidedCount}} / {{certificate.rsaNumberOfServices}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
